module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ContactBoxImage":{"alt":"Obrázek potřebujete pomoci?"}},"de":{"ContactBoxImage":{"alt":"Bild Sie brauchen Hilfe?"}},"sk":{"ContactBoxImage":{"alt":"Obrázok potrebujete pomôcť?"}}}')
  delete Component.options._Ctor
}
